import classNames from "classnames";
import { PropsWithChildren } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleX } from "@fortawesome/sharp-regular-svg-icons";

import styles from "./alert.module.scss";

type AlertProps = {
  variant: "error";
  title?: string;
  link?: {
    href: string;
    text: string;
  };
};

type AlertIconProps = Pick<AlertProps, "variant">;

const AlertIcon = ({ variant }: AlertIconProps) => (
  <FontAwesomeIcon
    icon={faCircleX}
    className={classNames({
      [styles.iconVariantError]: variant === "error",
    })}
  />
);

export const Alert = ({
  variant,
  title,
  link,
  children,
}: PropsWithChildren<AlertProps>) => (
  <div
    className={classNames(styles.alert, {
      [styles.alertVariantError]: variant === "error",
    })}
  >
    <AlertIcon variant={variant} />
    <div className={styles.content}>
      {title && <span className={styles.title}>{title}</span>}
      {children}
      {link && (
        <a className={styles.link} href={link.href}>
          {link.text}
        </a>
      )}
    </div>
  </div>
);
